import React, { useState } from 'react';
import { Card } from '../../shared';
import { CardClientDetailsFooter } from './card-client-details-footer';
import { CardClientDetailsBody } from './card-client-details-body';
import { CardClientDetailsHeader } from './card-client-details-header';
import './card-clients.scss';
export var CardClientDetails = function (_a) {
    var client = _a.client, cases = _a.cases;
    var _b = useState(false), expanded = _b[0], setExpanded = _b[1];
    var handleExpand = function () {
        setExpanded(!expanded);
    };
    return (React.createElement(Card, null,
        React.createElement(CardClientDetailsHeader, { firstName: client.firstName, surname: client.surname, address: client.address, email: client.email, mobileNumber: client.mobileNumber }),
        React.createElement(CardClientDetailsBody, { cases: !expanded ? cases === null || cases === void 0 ? void 0 : cases.slice(0, 3) : cases }),
        React.createElement(CardClientDetailsFooter, { expanded: expanded, handleExpand: handleExpand, existingCases: cases === null || cases === void 0 ? void 0 : cases.length })));
};
